/* Global provider for kiwi skin reward modal. Wrap around routes so any
   page can trigger the modal via useKiwiReward(). */

import { useState, useCallback, type ReactNode } from "react";
import type { KiwiSkinConfig } from "@/types/kiwiSkin";
import { KiwiRewardClassic } from "@/components/brand/KiwiRewardModal";
import { KiwiRewardContext } from "@/contexts/kiwiRewardContextValue";

interface KiwiRewardProviderProps {
  children: ReactNode;
}

export function KiwiRewardProvider({ children }: KiwiRewardProviderProps) {
  const [rewardSkin, setRewardSkin] = useState<KiwiSkinConfig | null>(null);

  const triggerReward = useCallback((skin: KiwiSkinConfig) => {
    setRewardSkin(skin);
  }, []);

  const dismissReward = useCallback(() => {
    setRewardSkin(null);
  }, []);

  return (
    <KiwiRewardContext value={{ triggerReward }}>
      {children}
      {rewardSkin && (
        <KiwiRewardClassic
          open={true}
          onOpenChange={(open) => { if (!open) dismissReward(); }}
          skin={rewardSkin}
        />
      )}
    </KiwiRewardContext>
  );
}
